<div class="importar-xml-etapa">
  <div class="section-container importar-xml-section-container">
    <div class="section-title">
      <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
      <span>Natureza de operação</span>
    </div>
    <p class="section-sub-title">Confirme a natureza de operação: ela define os CFOPs de entrada e o tratamento fiscal da nota.</p>

    <app-alert-card type="info" icon="info">
      <strong>A natureza define a classificação fiscal desta nota.</strong>
      CFOP de entrada, CST e tratamento tributário de cada item. Os valores de base, alíquota e imposto continuam sendo os informados no XML do fornecedor.
    </app-alert-card>

    <app-alert-card type="warning" icon="info" title="Natureza informada na NF (saída do emitente)">
      {{ descricaoNaturezaOperacaoXml || '-' }}
    </app-alert-card>

    <mat-form-field appearance="outline" class="w-100 mt-3" subscriptSizing="dynamic">
      <mat-label>Natureza de entrada (no seu cadastro)</mat-label>
      <mat-select [ngModel]="idNaturezaOperacaoSistema" (ngModelChange)="onNaturezaChange($event)">
        @for (nat of listaNaturezaOperacao; track nat.id) {
        <mat-option [value]="nat.id">{{ nat.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
